import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap'
import KapalService from '../../../../services/kapal/KapalService'
import { AsyncPaginate } from 'react-select-async-paginate'
import SweetAlert from 'react-bootstrap-sweetalert'
import UserService from '../../../../services/user/UserService'

const ModalTindakLanjutEvp = ({ showTLEvp, handleCloseShowTLEvp, dataDisposisi, dataPpmKapal, reloadList, isEdit }) => {
    let kapalService = useMemo(() => new KapalService(), [])
    let userService = useMemo(() => new UserService(), [])

    const fetchAllData = useCallback(async () => {
        if (!dataDisposisi?.noTugas || dataDisposisi.idDisposisi !== 21) {
            // console.log("data Kapal atau data disposisi kosong")
            return
        }

        try {
            const nomorTugas = dataDisposisi.noTugas.split("-")

            const [resKesimpulan, resPejabat] = await Promise.allSettled([
                kapalService.getKesimpulanById(nomorTugas[1]),
                userService.getPegawaiById(dataDisposisi.nipPejabat)
            ])


            setValueKesimpulanOpt(resKesimpulan.value?.data)
            setValuePejabatOpt(resPejabat.value?.data)
        } catch (error) {

        }
    }, [kapalService, dataDisposisi, userService])

    useEffect(() => {
        let isMounted = true;
        if (!dataPpmKapal || !dataDisposisi) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [dataPpmKapal, dataDisposisi, fetchAllData]);

    const [valueKesimpulanOpt, setValueKesimpulanOpt] = useState(null)
    const onChangeKesimpulan = e => {
        setValueKesimpulanOpt(e)
    }

    async function loadOptionKesimpulan(search, loadedOption, { page = 1 }) {
        const response = await kapalService.listKesimpulan(dataDisposisi.idDisposisi)
        return {
            options: response.data,
        }
    }

    const [valuePejabatOpt, setValuePejabatOpt] = useState(null)
    async function loadOptionPejabatTtd(search, loadedOption, { page = 1 }) {
        const response = await userService.listPegawai(search, localStorage.getItem('kdUnit'), page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangePejabatOpt = e => {
        setValuePejabatOpt(e)
    }

    const [showConfirmProses, setShowConfirmProses] = useState(false)
    const handleCloseConfirmProses = () => setShowConfirmProses(false)
    const handleClickConfirmProses = () => {
        setShowConfirmProses(true)
    }

    const [loadingProses, setLoadingProses] = useState(false)
    const [showProsesSuccess, setShowProsesSuccess] = useState(false)
    const [showProsesFailed, setShowProsesFailed] = useState(false)

    const handleCloseSuccess = () => {
        setShowProsesSuccess(false)
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleCloseFailed = () => {
        setShowProsesFailed(false)
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleClickProses = async () => {
        setLoadingProses(true)
        try {
            let dataDispo = {
                ...dataDisposisi,
                noTugas: 'TLEVP-' + valueKesimpulanOpt.idKesimpulan + '-' + dataPpmKapal.nomorAjuKapal,
                tglTugas: new Date(),
                nipPejabat: valuePejabatOpt.nip,
                nmPejabat: valuePejabatOpt.nama
            }
            await kapalService.savePenugasan(dataDispo)

            let jsonDisposisi
            if (valueKesimpulanOpt.idKesimpulan === 15) {
                jsonDisposisi = {
                    nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                    idDisposisi: valueKesimpulanOpt.idDisposisiNext,
                    noTugas: 'PTGH-' + valueKesimpulanOpt.idKesimpulan + '-' + dataPpmKapal.nomorAjuKapal,
                    tglTugas: new Date(),
                    createdBy: localStorage.getItem('userId'),
                    createdDate: new Date(),
                    nipPejabat: valuePejabatOpt.nip,
                    nmPejabat: valuePejabatOpt.nama
                }
            } else {
                jsonDisposisi = {
                    nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                    idDisposisi: valueKesimpulanOpt.idDisposisiNext,
                    createdBy: localStorage.getItem('userId'),
                    createdDate: new Date()
                }
            }
            await kapalService.savePenugasan(jsonDisposisi)

            let jsonStatus = {
                nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                kodeStatus: valueKesimpulanOpt.kdStatusNext,
                waktuStatus: new Date(),
                createdBy: localStorage.getItem("userId"),
                createdAt: new Date()
            }

            await kapalService.saveKapalStatus(jsonStatus)

            let jsonKapal = {
                ...dataPpmKapal,
                kodeStatus: valueKesimpulanOpt.kdStatusNext,
            }
            await kapalService.saveKapalHeader(jsonKapal)

            setShowConfirmProses(false)
            setShowProsesSuccess(true)

        } catch (error) {
            setShowConfirmProses(false)
            setShowProsesFailed(true)
        }
        setLoadingProses(false)
    }


    return (
        <>
            <Modal
                show={showTLEvp}
                onHide={handleCloseShowTLEvp}
                size='lg'
                centered
            >
                <Modal.Header>
                    <Modal.Title><h5>Tindak Lanjut Evaluasi Permohonan</h5></Modal.Title>
                    {localStorage.getItem("role") !== "7" && <span className='text-danger'>Akun Pusat Tidak Diperkenankan Proses Tindak Lanjut Evaluasi Permohonan</span>}
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Tindak Lanjut</Form.Label>
                                    <Col sm="8">
                                        <AsyncPaginate
                                            loadOptions={loadOptionKesimpulan}
                                            value={valueKesimpulanOpt}
                                            getOptionValue={(option) => option.idKesimpulan}
                                            getOptionLabel={(option) => option.urKesimpulan}
                                            additional={{
                                                page: 0,
                                            }}
                                            onChange={onChangeKesimpulan}
                                            isDisabled={!isEdit}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Pejabat</Form.Label>
                                    <Col sm="8">
                                        <AsyncPaginate
                                            loadOptions={loadOptionPejabatTtd}
                                            value={valuePejabatOpt}
                                            getOptionLabel={(option) => option.nip + ' - ' + option.nama}
                                            getOptionValue={(option) => option.nip}
                                            additional={{
                                                page: 1
                                            }}
                                            onChange={onChangePejabatOpt}
                                            isDisabled={!isEdit}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {isEdit && localStorage.getItem("role") === "7" && <Button variant="primary" size="sm" onClick={() => handleClickConfirmProses()} >Proses</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={handleCloseShowTLEvp}>Batal</Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmProses &&
                <SweetAlert
                    title="Proses?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingProses ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickProses}
                    onCancel={handleCloseConfirmProses}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingProses}
                    reverseButtons
                >
                    {loadingProses && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showProsesSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data  Berhasil"
                    onConfirm={handleCloseSuccess}
                    btnSize="sm"
                />
            }
            {
                showProsesFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Gagal"
                    onConfirm={handleCloseFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalTindakLanjutEvp